import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { EMPTY_OBJECT } from '../../../constants/common'
import { ProfileActionsWidgetItem } from '../ProfileActionsWidgetItem'
import { useProfileWidgetsHideContext } from '../Widget.hooks'

import {
  PROFILE_ACTIONS_WIDGET_HIDE_WIDGETS_BUTTON_TOOLTIP_KEY,
  ProfileActionsWidgetHideWidgetsButtonAction,
} from './ProfileActionsWidgetHideWidgetsButton.constants'

import * as styles from './ProfileActionsWidgetHideWidgetsButton.module.css'

import SwitcherIcon from '../../../icons/switcher-right.svg'

function ProfileActionsWidgetHideWidgetsButton({
  Component = ProfileActionsWidgetItem,
  tooltipPlacement,
}) {
  const { t } = useTranslation()

  const widgetsHide = useProfileWidgetsHideContext()

  const { handleToggleWidgetsHidden, isWidgetsHidden } =
    widgetsHide ?? EMPTY_OBJECT

  const action = isWidgetsHidden
    ? ProfileActionsWidgetHideWidgetsButtonAction.show
    : ProfileActionsWidgetHideWidgetsButtonAction.hide

  const iconClassName = classNames(styles.icon, {
    [styles.widgetsHidden]: isWidgetsHidden,
  })

  return widgetsHide ? (
    <Component
      beforeIconProps={{
        Icon: SwitcherIcon,
        iconProps: { className: iconClassName },
      }}
      qaName={action}
      tooltip={t(
        PROFILE_ACTIONS_WIDGET_HIDE_WIDGETS_BUTTON_TOOLTIP_KEY[action]
      )}
      tooltipPlacement={tooltipPlacement}
      value={action}
      onClick={handleToggleWidgetsHidden}
    />
  ) : null
}

export default ProfileActionsWidgetHideWidgetsButton
